import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const recipeColorVariant = {
  recipe: {
    chicken: {
      background: '$tertiary-200',
      '&:hover, &:focus': {
        backgroundColor: '$tertiary-200',
      },
    },
    beef: {
      background: '$primary-700',
      '&:hover, &:focus': {
        backgroundColor: '$primary-700',
      },
    },
    duck: {
      background: '$primary-700',
      '&:hover, &:focus': {
        backgroundColor: '$primary-700',
      },
    },
    turkey: {
      background: '$tertiary-400',
      '&:hover, &:focus': {
        backgroundColor: '$tertiary-400',
      },
    },
    lamb: {
      background: '$primary-700',
      '&:hover, &:focus': {
        backgroundColor: '$primary-700',
      },
    },
    venison: {
      background: '$tertiary-400',
      '&:hover, &:focus': {
        backgroundColor: '$tertiary-400',
      },
    },
  },
}

export const Span = styled('span', {
  fontWeight: '$medium',
})

export const InfoWrapper = styled('div', {
  width: '100%',
  '& > div': {
    marginTop: 0,
  },
})

export const DesktopHeroWrapper = styled('div', {
  display: 'none',
  position: 'relative',

  width: '50%',
  '& > div:first-child': {
    width: '100%',
  },

  '@bp3': {
    display: 'block',
  },
})

export const PricePerUnit = styled(Text, {
  textAlign: 'center',
  marginTop: '$3',
  marginBottom: '$2',
  '@bp3': {
    margin: 'auto',
  },
})

export const Spacer = styled('div', {
  height: '30px',
})

export const Description = styled(Text, {
  maxWidth: '450px',

  '& span': {
    whiteSpace: 'nowrap',
  },

  '@bp3': {
    maxWidth: '500px',
  },
})

export const HeroHeader = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '$1',

  '@bp3': {
    marginTop: '$7',
  },
})

export const ItemCounterWrapper = styled('div', {
  '& > div': {
    marginBottom: '$4',
    marginTop: 0,

    '@bp3': {
      marginBottom: '$2',
    },
  },
})

export const Discount = styled('p', {
  marginBottom: '$2',
  marginTop: '$3 !important',
  textAlign: 'center',
  color: '$primary-500',
  fontSize: '$headline',
  fontStyle: 'italic',
  maxWidth: '380px',

  '@bp3': {
    maxWidth: '420px',
  },
})

export const PriceWrapper = styled('div', {
  '& > span': {
    fontWeight: '$medium',
    marginTop: 0,
  },
})

export const BadgeWrapper = styled('div', {
  width: '200px',
  height: '200px',
  borderRadius: '100%',
  background: '$primary-500',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  border: 'solid',
  borderColor: '$accent-white',
  borderWidth: '4px',
})

export const BadgeOutline = styled(BadgeWrapper, {
  width: '215px',
  height: '215px',
  background: 'transparent',
  border: 'solid',
  borderColor: '$accent-white',
  borderWidth: '2px',
  borderRadius: '100%',
  position: 'absolute',
  right: '30px',
  top: '70px',
  '@bp4': {
    right: '100px',
    top: '90px',
  },
})
